import React, { useState, useEffect } from 'react';
import { CardHeader } from 'reactstrap';
import { format } from 'date-fns';
import { Categories, DefaultCategory } from '../../../static/categories';
import './PostCard.css';

export const PostCardHeader = ({ post }) => {
    const [reviewsCount, setReviewsCount] = useState([]);

    useEffect(() => {
        let arr = [...reviewsCount];
        post.question.questions.forEach(elem => {
            arr = Array.from(new Set(arr.concat(elem.reviews)));
        });
        setReviewsCount(arr);
    }, []);

    const postCategory =
        post.category && Categories[post.category] ? Categories[post.category] : DefaultCategory;
    const textStyle = { backgroundColor: `${postCategory.color}` };
    const lastNameInitial = post.user && post.user.lastName ? post.user.lastName.slice(0, 1) : '';
    return (
        <CardHeader className={'d-flex justify-content-between align-items-center p-0 card-info'}>
            <div className="d-flex justify-content-between align-items-center post-info">
                <div style={textStyle}>
                    <h6 className="mr-3 card-info category-label">{postCategory.label}</h6>
                </div>
                <h6 className="mr-3 card-info">
                    {reviewsCount && reviewsCount.length}&nbsp;Reviews
                </h6>
                <h6 className="mr-3 card-info post-date">{`${
                    post.createdTimestamp
                        ? format(post.createdTimestamp.toDate(), 'DD/MM/YYYY')
                        : ''
                }`}</h6>
                <h6 className="card-info">
                    {post.user && `${post.user.firstName} ${lastNameInitial} .`}
                </h6>
            </div>
            <h6 className={'font-weight-bold mr-4 card-info donation-amount'}>
                {' '}
                &#163;{post.totalDonations} Donated{' '}
            </h6>
        </CardHeader>
    );
};
